@app.directive 'matrixItemMediaForm', (AnalyticsService) ->
  restrict: 'E'
  scope: {}
  controller: ->
    @setItem = (selectedItem, currentItem)->
      angular.forEach currentItem.content, (value, key) ->
        if selectedItem.hasOwnProperty(key)
          currentItem.content[key] = selectedItem[key]
    this
  controllerAs: 'matrixItemMediaForm'
  templateUrl: "/assets/templates/components/matrix/matrixItem/matrixItemMedia/matrixItemMediaForm.html"
  bindToController: {
    content: '='
    descriptionCharLimit: '='
    showLikes: '='
    loadImageOnEnterViewport: '='
    source: '@'
  }
